export default "__VITE_ASSET__BvYDYTqe__"